<script setup lang="ts">
import { ref, onMounted } from 'vue'
// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// State -----------------------------------------
const currentId = ref(0)
const { lang } = props

// Getters ---------------------------------------

// Methods ---------------------------------------
function setActive(id: number) {
  currentId.value = id
  if (!document.querySelector('.bullet.blink')) {
    update()
  }
}

function update() {
  const el = <HTMLImageElement>document.querySelector(`.bullet.bullet-${currentId.value}`)
  document.querySelectorAll('.bullet.blink').forEach((e) => e.classList.remove('blink'))
  el?.offsetHeight
  el?.classList.add('blink')
}

// Events ----------------------------------------

// Main Setup ------------------------------------
defineExpose({
  setActive,
  update,
})
// -----------------------------------------------
</script>

<template>
  <template v-for="n in 10">
    <img :class="['bullet-bg', `bullet-${n}`, `lang-${lang}`]" src="/images/home/bullet.png" />
    <img :class="['bullet', `bullet-${n}`, `lang-${lang}`]" src="/images/home/bullet-a.png" @animationend="update" />
  </template>
</template>

<style scoped>
/* ------------------------ */
.bullet-bg {
  position: absolute;
}

.bullet {
  position: absolute;
  opacity: 0;
}

/* prettier-ignore */
.bullet-1 { left: 794px; top: 398px; }
/* prettier-ignore */
.bullet-2 { left: 794px; top: 536px; }
/* prettier-ignore */
.bullet-3 { left: 794px; top: 676px; }
/* prettier-ignore */
.bullet-4 { left: 794px; top: 817px; }
/* prettier-ignore */
.bullet-5 { left: 1335px; top: 398px; }
/* prettier-ignore */
.bullet-6 { left: 1335px; top: 480px; }
/* prettier-ignore */
.bullet-7 { left: 1335px; top: 564px; }
/* prettier-ignore */
.bullet-8 { left: 1335px; top: 649px; }
/* prettier-ignore */
.bullet-9 { left: 1335px; top: 732px; }
/* prettier-ignore */
.bullet-10 { left: 1335px; top: 816px; }
/* ------------------------ */
/* prettier-ignore */
.bullet-1.lang-en { left: 794px; top: 398px; }
/* prettier-ignore */
.bullet-2.lang-en { left: 794px; top: 519px; }
/* prettier-ignore */
.bullet-3.lang-en { left: 794px; top: 640px; }
/* prettier-ignore */
.bullet-4.lang-en { left: 794px; top: 762px; }
/* prettier-ignore */
.bullet-5.lang-en { left: 794px; top: 848px; }
/* prettier-ignore */
.bullet-6.lang-en { left: 1335px; top: 397px; }
/* prettier-ignore */
.bullet-7.lang-en { left: 1335px; top: 518px; }
/* prettier-ignore */
.bullet-8.lang-en { left: 1335px; top: 604px; }
/* prettier-ignore */
.bullet-9.lang-en { left: 1335px; top: 727px; }
/* prettier-ignore */
.bullet-10.lang-en { left: 1335px; top: 849px; }
/* ------------------------ */
</style>
